import { ImportTypeLocation } from '@/api/admin/location';
import { Button } from '@/components/ui/button';
import { ColumnDef } from '@tanstack/react-table';
import { ArrowUpDown } from 'lucide-react';

import { UpdateLocation } from './sheet-update';

export const columns: ColumnDef<ImportTypeLocation>[] = [
	{
		accessorKey: 'importTypeCompLocXRefId',
		header: ({ column }) => (
			<div className="flex justify-center">
				<Button
					variant="ghost"
					onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
				>
					Company Location Reference Id
					<ArrowUpDown />
				</Button>
			</div>
		),
		cell: ({ row }) => {
			return (
				<div className="flex justify-center whitespace-nowrap font-medium">
					{row.original.importTypeCompLocXRefId}
				</div>
			);
		},
	},
	{
		accessorKey: 'brandName',
		header: ({ column }) => (
			<div className="flex justify-center">
				<Button
					variant="ghost"
					onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
				>
					Company Location Name
					<ArrowUpDown />
				</Button>
			</div>
		),
		cell: ({ row }) => {
			return (
				<div className="flex justify-center whitespace-nowrap font-medium">
					{row.original.brandName}
				</div>
			);
		},
	},
	{
		id: 'actions',
		cell: ({ row }) => (
			<div>
				<UpdateLocation location={row.original} />
			</div>
		),
	},
];
